import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const StatusSuccessIcon = React.forwardRef<SVGSVGElement, IconProps>(function StatusSuccessIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"/>
        </IconBase>
    );
});
